const VoyageExchangeList = () => import('Views/voyageExchange/voyageExchange-list-new-ui');
const VoyageExchangeMetaData = () => import('Views/voyageExchange/voyageExchange-metaData-new-ui');

export default[
  { path: '/voyageExchange-list', component: VoyageExchangeList },
  { path: '/voyageExchange-metaData/:id', component: VoyageExchangeMetaData },
];



// WEBPACK FOOTER //
// ./src/router/voyageExchange.js